"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useMemo } from "react";
const DayMapContext = /*#__PURE__*/ createContext(null);
function DayMapProvider({ children, dayMap = {
    variant: 'day'
}, mode = 'single', isMobile = false, holidays }) {
    const context = useMemo(()=>({
            dayMap,
            mode,
            isMobile,
            holidays
        }), [
        dayMap,
        mode,
        isMobile,
        holidays
    ]);
    return /*#__PURE__*/ jsx(DayMapContext.Provider, {
        value: context,
        children: children
    });
}
export { DayMapContext, DayMapProvider };
